import { EMAIL_DOMAIN_RULE } from '../../_constants';

export default (value) => typeof value === 'string' && EMAIL_DOMAIN_RULE.test(value);
